import { CSSProperties } from 'react'
import { DownloadOutlined } from '@ant-design/icons'

import Button from '~/core/Button'
import Tooltip from '~/core/Tooltip'

type DownloadCpqQuoteButtonProps = {
    style: CSSProperties
    onODP: boolean
    quotePdfUrl: string | undefined
}

const DownloadCpqQuoteButton = (props: DownloadCpqQuoteButtonProps) => {
    const { style, onODP, quotePdfUrl = '' } = props

    return (
        <Tooltip title="Download a copy of the original quote you purchased.">
            <a style={style} href={quotePdfUrl}>
                <Button type="default">
                    <DownloadOutlined />
                    {onODP ? 'Purchased quote' : 'Download purchased quote'}
                </Button>
            </a>
        </Tooltip>
    )
}

export default DownloadCpqQuoteButton
